import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { RectangleDown } from './RectangleDown';
import { RectangleUp } from './RectangleUp';
import { TOrdersItemProps } from './types';

export const OrdersItem: FC<TOrdersItemProps> = ({ text, amount, percent, isAmount = false }) => (
	<Box
		sx={{
			width: '50%',
			textAlign: 'center',
		}}
	>
		<Typography
			sx={{
				fontSize: '.9rem',
				fontWeight: 'bold',
				color: '#016193c0',
			}}
		>
			{text}
		</Typography>
		<div
			style={{
				fontSize: '1.8rem',
				fontWeight: 'bold',
				color: '#016193',
				margin: '10px 0',
			}}
		>
			{isAmount ? (
				<AmountAndCurrency amount={amount} currency="EUR" size={1.8} bold type="symbol" />
			) : (
				<Typography
					sx={{
						fontSize: '1.8rem',
						fontWeight: 'bold',
						color: '#016193',
						margin: '10px 0',
					}}
				>
					{amount}
				</Typography>
			)}
		</div>
		<Typography
			sx={{
				// display: 'flex',
				flexDirection: 'column',
				justifyContent: 'inherit',
				color: `${percent > 0 ? 'success.main' : percent < 0 ? '#d32f2fb0' : 'black'}`,
				textAlign: 'center',
				ml: '12px',
			}}
		>
			{percent > 0 ? <RectangleUp /> : percent < 0 ? <RectangleDown /> : null}
			<span>{Math.abs(percent)}%</span>
		</Typography>
	</Box>
);
